// extracted by mini-css-extract-plugin
export default {"container":"styles_container__qpwrk","titleContainer":"styles_titleContainer__91Cqe","title":"styles_title__0xWIw","required":"styles_required__5U7b2"};